import { Observable } from "@configura/web-utilities";
import React, { ReactNode, useEffect, useState } from "react";

export const APIDataContext = React.createContext<any[]>(undefined as any);
const observable = new Observable<unknown>();

interface Props {
	children?: ReactNode;
}

export function APIDataContextProvider(props: Props) {
	const [data, setData] = useState<any[]>([]);

	useEffect(() => {
		function callback(args: any) {
			setData((prev) => {
				const copy = prev.slice();
				copy.unshift(args);
				return copy;
			});
		}
		observable.listen(callback);

		return () => {
			observable.stopListen(callback);
		};
	}, [data]);

	return <APIDataContext.Provider value={data}>{props.children}</APIDataContext.Provider>;
}
